import React from 'react';
import { Link as InternalLink } from 'react-router-dom';
import { LinkWrapper } from "./Link.styles";
export var Link = function Link(_ref) {
  var url = _ref.url,
      external = _ref.external,
      label = _ref.label,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick;

  var handleClick = function handleClick(e) {
    e.preventDefault();
    if (onClick) onClick();
  };

  return React.createElement(LinkWrapper, {
    className: className,
    style: style,
    href: url,
    to: external || onClick ? undefined : url,
    as: external || onClick ? undefined : InternalLink,
    target: external ? '_blank' : '_self',
    onClick: onClick ? handleClick : undefined
  }, label || children);
};